import type { IPerson } from '~/types/person/models'
import { Name } from '~/cynqueModules/dataObjects/Name'

export function Person(o: IPerson): IPerson {
  const fn = '[cynqueModules/dataObjects/Person.ts] Person |'
  if (!o) {
    throw new Error(`${fn} Person called with falsey person`)
  }

  if (!o.name) {
    throw new Error(`${fn} Person called with falsey person.name`)
  }

  const obj = { ...o }
  obj.name = Name(o.name)
  obj.avatar = {
    descr: obj.name.initials ?? '',
    type: 'person',
  }
  obj.descr = obj.name.descr + (o.phone ? '\n' + o.phone : '')
  if (typeof obj.name.descr === 'string') {
    obj.label = obj.name.descr
  }
  // console.debug(`${fn} returning`, obj)
  return obj
}
